
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shadowban-test/[type]",
      function () {
        return require("private-next-pages/shadowban-test/[type]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shadowban-test/[type]"])
      });
    }
  